<nz-modal
  nzWrapClassName=""
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="onEmitClose()"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}">
  <ng-template #modalTitle>
  </ng-template>

  <ng-template #modalContent>
    <div class="d-flex justify-content-center align-items-center flex-column">
      <img loading="lazy" src="./../../../assets/images/increase-plan.jpg" alt="" style="height: 220px;">
      <p class="text-info mt-xlg">
        Crece tu plan para poder agregar más {{ resource }}
      </p>
      <button nz-button nzType="primary" class="mt-md" (click)="onGotoPlans()">Crecer plan</button>
    </div>
  </ng-template>

  <ng-template #modalFooter>
  </ng-template>
</nz-modal>
